export default __webpack_public_path__ + "static/media/python.45b817ec.png";